export default __webpack_public_path__ + "static/media/navbar-icon-credit-limit.822c5633.svg";